export const PRIMARY = {
  chetwodeBlue: "hsla(234, 25%, 52%, 1)",
  midnightExpress: "hsla(234, 53%, 16%, 1)",
  frenchRose: "hsla(341, 92%, 62%, 1)",
  carnationPink: "hsla(341, 100%, 83%, 1)",
};

export const NEUTRAL = {
  white: "hsla(0, 0%, 100%, 1)",
  gray: "hsla(233, 10%, 56%, 1)",
};

export const GRADIENTS = {
  bluePersianRose:
    "linear-gradient(180deg, hsla(237,100%, 64%, 1), hsla(322,87%, 55%, 1))",
  tomatoPersianRose:
    "linear-gradient(180deg, hsla(13, 100%, 64%, 1), hsla(322, 87%, 55%, 1))",
  whiteTransparency:
    "linear-gradient(0deg, hsla(0, 0%, 100%, 0.5), hsla(0, 0%, 100%, 0.5))",
};
